module.exports = __webpack_public_path__ + "media/images/icons/outlined/file-search-5dac0cf77ceb793f082a7796537e76b1.svg";